// extracted by mini-css-extract-plugin
module.exports = {"emailStyle":"_1ZwGRw3fNqYFXYSWyqps_p"};